import {
  ChartBarIcon,
  MagnifyingGlassIcon,
  DocumentTextIcon,
  ClockIcon,
  ArrowTrendingUpIcon,
  MagnifyingGlassCircleIcon,
  ArrowTrendingDownIcon,
  PlusCircleIcon,
  MinusCircleIcon,
  QuestionMarkCircleIcon,
  ShoppingCartIcon,
  AdjustmentsHorizontalIcon,
  KeyIcon,
  DocumentMagnifyingGlassIcon,
  CheckBadgeIcon,
  TagIcon,
  LightBulbIcon,
  BeakerIcon,
  GlobeAltIcon,
  DocumentChartBarIcon,
  CpuChipIcon,
  CodeBracketIcon,
  BuildingOfficeIcon,
  PencilIcon,
  FanIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';
import { BugAntIcon } from '@heroicons/react/24/outline';
import { FaBrain } from 'react-icons/fa';

// Navigation configuration
export const NAVIGATION_CONFIG = {
  analysis: {
    title: 'Performance',
    key: 'analysis',
    items: [
      { 
        id: 'analysis-overview', 
        label: 'Domain Overview',
        path: '/overview',
        icon: GlobeAltIcon,
        exact: true
      },
      { 
        id: 'main-analysis', 
        label: 'Pages',
        path: '/analysis',
        icon: DocumentChartBarIcon,
        exact: true
      },
      { 
        id: 'keywords', 
        label: 'Keywords',
        path: '/keywords',
        icon: KeyIcon,
        exact: true
      },
      { 
        id: 'overlap', 
        label: 'Overlaps',
        path: '/overlap',
        icon: DocumentTextIcon,
        exact: true
      },
      {
        id: 'historical-report',
        label: 'Performance Over Time',
        path: '/performance',
        icon: ClockIcon,
        exact: true
      }
    ]
  },
  ai_tools: {
    title: 'AI Tools & Simulators',
    key: 'ai_tools',
    items: [
      {
        id: 'ai-playground',
        label: 'AI Playground',
        path: '#', // Special action - no route needed
        icon: SparklesIcon,
      },
      {
        id: 'prompt-burst',
        label: 'Prompt Burst',
        path: '/prompt-burst',
        icon: BeakerIcon,
        badge: 'NEW'
      },
      {
        id: 'ai-crawler',
        label: 'AI Crawler',
        path: '/ai-crawler',
        icon: BugAntIcon,
        badge: 'NEW'
      },
      {
        id: 'content-strategy',
        label: 'Content Strategy',
        path: '/content-strategy',
        icon: PencilIcon,
        badge: 'NEW'
      }
    ]
  },
  tools: {
    title: 'SEO Tools',
    key: 'tools',
    items: [
      {
        id: 'meta-optimizer',
        label: 'Meta Tag Optimizer',
        path: '/tools/meta-tag-optimizer',
        icon: TagIcon
      },
      {
        id: 'search-intent',
        label: 'Search Intent',
        path: '/tools/search-intent-analysis',
        icon: MagnifyingGlassIcon
      },
      {
        id: 'content-gaps',
        label: 'Content Gaps',
        path: '/tools/content-gaps',
        icon: DocumentMagnifyingGlassIcon
      },
      {
        id: 'quality-rater',
        label: 'Quality Rater',
        path: '/tools/quality-rater-analysis',
        icon: CheckBadgeIcon
      },
      {
        id: 'helpful-content',
        label: 'Helpful Content',
        path: '/tools/helpful-content-analysis',
        icon: LightBulbIcon
      },
      {
        id: 'document-structure',
        label: 'Document Structure',
        path: '/tools/document-structure',
        icon: CodeBracketIcon,
        badge: 'BETA'
      }
    ]
  },
  support: {
    title: 'Support',
    key: 'support',
    items: [
      {
        id: 'privacy-policy',
        label: 'Privacy Policy',
        path: 'https://queryburst.com/privacy-policy/',
        icon: DocumentTextIcon,
        external: true
      },
      {
        id: 'terms-of-service',
        label: 'Terms of Service',
        path: 'https://queryburst.com/terms-of-service/',
        icon: DocumentTextIcon,
        external: true
      },
      {
        id: 'support-email',
        label: 'Contact Support',
        path: 'mailto:support@queryburst.com',
        icon: QuestionMarkCircleIcon,
        external: true
      }
    ]
  }
}; 